import React from 'react'
import Container from '../../components/Container/Container'

function ContainerPage() {
  return (
    <Container />
  )
}

export default ContainerPage